import { useEffect } from 'react';
import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { Label } from '@/components/ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';

interface PaymentAccountSelectProps {
  sciId?: string;
  value: string;
  onChange: (accountId: string) => void;
}

export function PaymentAccountSelect({ sciId, value, onChange }: PaymentAccountSelectProps) {
  const { data: accounts = [], isLoading } = useQuery({
    queryKey: ['sci-payment-accounts', sciId],
    enabled: !!sciId,
    queryFn: async () => {
      const { data, error } = await supabase.from('sci_payment_accounts')
        .select('id, label, iban, is_default')
        .eq('sci_id', sciId!)
        .order('is_default', { ascending: false })
        .order('created_at');
      if (error) throw error;
      return data;
    },
  });

  useEffect(() => {
    if (accounts.length && !accounts.some((account) => account.id === value)) {
      onChange(accounts.find((account) => account.is_default)?.id || accounts[0].id);
    }
  }, [accounts, value, onChange]);

  if (!sciId) return null;
  return <div className="space-y-2">
    <Label>Compte bancaire pour ce contrat</Label>
    {isLoading ? <p className="text-sm text-muted-foreground">Chargement des comptes...</p> : accounts.length ? <Select value={value || undefined} onValueChange={onChange}>
      <SelectTrigger><SelectValue placeholder="Sélectionner un compte" /></SelectTrigger>
      <SelectContent>{accounts.map((account) => <SelectItem key={account.id} value={account.id}>
        {account.label} ···· {account.iban.slice(-4)}{account.is_default ? ' (principal)' : ''}
      </SelectItem>)}</SelectContent>
    </Select> : <p className="text-sm text-muted-foreground">Ajoutez un compte bancaire dans la fiche SCI pour afficher des coordonnées de paiement.</p>}
  </div>;
}
